import { useState } from 'react'
import { Button, Divider, Skeleton } from 'antd'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
import AptitudeTable from './AptitudeTable'
import UploadModal from './UploadModal'
import { buildRequiredTip } from './helpers'
import { AptitudeAttachProps, AptitudeFile } from './typing'
import Style from './aptitudeAttach.module.scss'

// 编辑页「资料附件」模块：头部(上传按钮+收起展开) + 资质表格 + 必填提示
const AptitudeAttach = (props: AptitudeAttachProps) => {
  const {
    dataSource = [],
    onChange,
    productCode,
    requiredAttachTypes = [],
    loading,
    defaultExpanded = true,
    oldTemp,
  } = props
  const [expanded, setExpanded] = useState(defaultExpanded)
  const [modalOpen, setModalOpen] = useState(false)

  const requiredTip = buildRequiredTip(requiredAttachTypes)

  // 弹框确认：暂存文件并入主列表
  const onModalOk = (files: AptitudeFile[]) => {
    onChange([...dataSource, ...files])
    setModalOpen(false)
  }

  return (
    <div className={Style.wrapper}>
      <div className={Style.header}>
        <span>资料附件</span>
        <div className={Style.actions}>
          <Button type="primary" size="small" onClick={() => setModalOpen(true)}>
            上传资质图片
          </Button>
          <span
            className={Style.collapseBtn}
            onClick={() => setExpanded((prev) => !prev)}
          >
            {expanded ? <UpOutlined /> : <DownOutlined />}
          </span>
        </div>
      </div>
      <Divider style={{ margin: '0' }} />
      {expanded && (
        <div className={Style.body}>
          <Skeleton loading={loading} active>
            <AptitudeTable dataSource={dataSource} onChange={onChange} />
            {requiredTip && <div className={Style.requiredTip}>{requiredTip}</div>}
            {oldTemp?.added && (
              <div style={{ color: 'red' }}>新增： {oldTemp.added}</div>
            )}
            {oldTemp?.deleted && (
              <div style={{ color: 'red' }}>删除： {oldTemp.deleted}</div>
            )}
          </Skeleton>
        </div>
      )}

      <UploadModal
        open={modalOpen}
        productCode={productCode}
        existedList={dataSource}
        onCancel={() => setModalOpen(false)}
        onOk={onModalOk}
      />
    </div>
  )
}

export default AptitudeAttach
import { useState } from 'react'
import { Button, Divider, Skeleton } from 'antd'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
import AptitudeTable from './AptitudeTable'
import UploadModal from './UploadModal'
import { buildRequiredTip } from './helpers'
import { AptitudeAttachProps, AptitudeFile } from './typing'
import Style from './aptitudeAttach.module.scss'

// 编辑页「资料附件」模块：头部(上传按钮+收起展开) + 资质表格 + 必填提示
const AptitudeAttach = (props: AptitudeAttachProps) => {
  const {
    dataSource = [],
    onChange,
    productCode,
    requiredAttachTypes = [],
    loading,
    defaultExpanded = true,
    oldTemp,
  } = props
  const [expanded, setExpanded] = useState(defaultExpanded)
  const [modalOpen, setModalOpen] = useState(false)

  const requiredTip = buildRequiredTip(requiredAttachTypes)

  // 弹框确认：暂存文件并入主列表
  const onModalOk = (files: AptitudeFile[]) => {
    onChange([...dataSource, ...files])
    setModalOpen(false)
  }

  return (
    <div className={Style.wrapper}>
      <div className={Style.header}>
        <span>资料附件</span>
        <div className={Style.actions}>
          <Button type="primary" size="small" onClick={() => setModalOpen(true)}>
            上传资质图片
          </Button>
          <span
            className={Style.collapseBtn}
            onClick={() => setExpanded((prev) => !prev)}
          >
            {expanded ? <UpOutlined /> : <DownOutlined />}
          </span>
        </div>
      </div>
      <Divider style={{ margin: '0' }} />
      {expanded && (
        <div className={Style.body}>
          <Skeleton loading={loading} active>
            <AptitudeTable dataSource={dataSource} onChange={onChange} />
            {requiredTip && <div className={Style.requiredTip}>{requiredTip}</div>}
            {oldTemp?.added && (
              <div style={{ color: 'red' }}>新增： {oldTemp.added}</div>
            )}
            {oldTemp?.deleted && (
              <div style={{ color: 'red' }}>删除： {oldTemp.deleted}</div>
            )}
          </Skeleton>
        </div>
      )}

      <UploadModal
        open={modalOpen}
        productCode={productCode}
        existedList={dataSource}
        onCancel={() => setModalOpen(false)}
        onOk={onModalOk}
      />
    </div>
  )
}

export default AptitudeAttach
